
import {Component, Mixins, Prop} from 'vue-property-decorator';
import Chart from "chart.js";
import moment from "moment";
import { Line, Bar } from "vue-chartjs";
import RestcommStatics from "@/consoleapi/api/restcomm/statics";
@Component
export default class Dashboard extends Mixins(Line, Bar) {
  @Prop() public staticData!: any ;

  public labels: string[] = [];
  public calls: number[] = [];
  public durations: number[] = [];

  public chartData: Chart.ChartData = {
    labels: this.labels,
    datasets: [{
      type: "bar",   // linear固定
      label: '# 通話呼数',
      data: this.calls,
      backgroundColor: 'rgba(55, 99, 132, 0.7)',
      borderColor: 'rgba(55,99,132,1)',
      borderWidth: 1,
      yAxisID: "y-axis-1", // 追加
    }, {
      type: "line",
      label: '# 通話時間(分)',
      data:  this.durations,
      backgroundColor: 'rgba(255, 99, 132, 0.7)',
      borderColor: 'rgba(255,99,132,1)',
      fill: false, // 追加
      borderWidth: 1,
      yAxisID: "y-axis-2", // 追加
    }]
    ,
  };
  public chartOptions: Chart.ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      yAxes: [{
        id: "y-axis-1",
        type: "linear",
        position: "left",
        ticks: {
          min: 0,
          stepSize: 1
        },
      }, {
        id: "y-axis-2",
        type: "linear",
        position: "right",
        ticks: {
          min: 0,
          stepSize: 1
        },
      }],
    }
  };

  setRenderChart() {
    this.renderChart(this.chartData, this.chartOptions);
  }

  findCallStaticDataFromDate(dataset: any, date: string) {
    const response = {
      'duration': 0,
      'count': 0,
    }
    for (const i in dataset) {
      const data = dataset[i];
      //console.log(date);
      //console.log(data["start_date"]);
      if (date === data["start_date"]) {
        response['duration'] = data['usage'];
        response['count'] = data['count'];
        return response;
      }
    }
    return response;
  }

  mounted() {
    const data = this.staticData;
    const start = moment(data.start);
    const end = moment(data.end);
    const dataset = this.staticData.data;
    const dates = end.diff(start, 'days');

    for(let i = 1; i<=dates; i++) {
      this.labels.push(start.format('YYYY-MM-d'));
      const statics = this.findCallStaticDataFromDate(dataset, start.format('YYYY-MM-DD'));
      this.durations.push(statics['duration']);
      this.calls.push(statics['count']);
      console.log(start.format('YYYY-MM-DD'));
      start.add(1, 'd');
    }
    this.setRenderChart();
//    this.getCallStatics();
  }
}
